export function str(val: unknown, fallback = ''): string {
  if (val == null) return fallback;
  if (typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean')
    return String(val);
  return fallback;
}

/** Prefer API display label; never surface raw UUID/CUID as a person name. */
export function actorLabel(display: unknown, rawId: unknown, fallback = '—'): string {
  const preferred = str(display).trim();
  if (preferred) return preferred;
  const raw = str(rawId).trim();
  if (!raw) return fallback;
  if (raw === 'system' || raw === 'seed') return 'Sistema';
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(raw)) {
    return 'Usuário não identificado';
  }
  if (raw.length >= 20 && /^[a-z0-9_-]+$/i.test(raw)) return 'Usuário não identificado';
  return raw;
}

export function asRecord(val: unknown): Record<string, unknown> {
  return (val ?? {}) as Record<string, unknown>;
}

/** Accepts a bare array or an API envelope `{ data: [] }`. */
export function asList(val: unknown): Record<string, unknown>[] {
  if (Array.isArray(val)) return val as Record<string, unknown>[];
  if (val && typeof val === 'object') {
    const record = val as Record<string, unknown>;
    if (Array.isArray(record.data)) return record.data as Record<string, unknown>[];
  }
  return [];
}

/** Reads `meta` from an API envelope; empty object otherwise. */
export function getMeta(val: unknown): Record<string, unknown> {
  if (val && typeof val === 'object' && !Array.isArray(val)) {
    const record = val as Record<string, unknown>;
    if (record.meta && typeof record.meta === 'object' && !Array.isArray(record.meta)) {
      return record.meta as Record<string, unknown>;
    }
  }
  return {};
}
